import fetchMerchandiseCategoriesList from 'actions/merchandise/fetchMerchandiseCategoriesList'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { EmptyArray } from 'lib/array/arrayUtils'
import getObjectKey from 'lib/object/getObjectKey'
import { useEffect } from 'react'

type ReturnType = [
  Array<string>,
  boolean,
  any | undefined,
]

interface Options {
  disabled?: boolean;
}

function useMerchandiseCategoriesList(filters: App.MerchandiseCategoryFilters | undefined, options: Options = {}): ReturnType {
  const dispatch = useAppDispatch()

  const key = getObjectKey(filters ?? {})
  const categoryList = useAppSelector(state => state.merchandise.merchandiseCategoryLists[key])
  const fetching = useAppSelector(state => state.merchandise.fetchingMerchandiseCategoryLists[key])
  const error = useAppSelector(state => state.merchandise.merchandiseCategoryListErrors[key])

  useEffect(() => {
    if (!options.disabled && filters) {
      dispatch(fetchMerchandiseCategoriesList(filters))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, key, options.disabled])

  return [
    categoryList ?? EmptyArray,
    (!!fetching || !categoryList) && !options.disabled,
    error,
  ]
}

export default useMerchandiseCategoriesList
